import { Contract, FormInput } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { FormEvent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IContractInputBaseProps } from '../../base/ContractInputBase';
import '../text/ContractInputAgreementText.scss';

interface IContractInputAgreementParagraphProps
  extends Omit<IContractInputBaseProps, 'name'> {}

const ContractInputAgreementParagraph = ({
  disabled,
  id,
  ...props
}: IContractInputAgreementParagraphProps) => {
  const { t } = useTranslation();
  const { itemNameById, displayMode, values } = useFormikContractHelpers();

  const onKeyDown = (event: FormEvent<HTMLTextAreaElement>) => {
    event.currentTarget.style.height = 'inherit';
    event.currentTarget.style.height = '0px';
    event.currentTarget.style.height = `${event.currentTarget.scrollHeight + 1}px`;
  };

  useEffect(() => {
    const textarea = document.querySelector<HTMLTextAreaElement>(
      `[name="${itemNameById(id)}.content.paragraphAgreementTemplate.defaultValue"]`
    );
    if (textarea) {
      textarea.style.height = 'inherit';
      textarea.style.height = '0px';
      textarea.style.height = `${textarea.scrollHeight + 1}px`;
    }
  }, [itemNameById, id, values]);

  return (
    <Contract.Input.Base
      {...props}
      id={id}
      classNames={[
        'contract-input-agreement',
        'contract-input-agreement-title',
      ]}
      name={`${itemNameById(id)}.content.paragraphAgreementTemplate.title`}
      placeholder={t('input.placeholder.paragraph-agreement-title')}>
      <FormInput.Field
        name={`${itemNameById(id)}.content.paragraphAgreementTemplate.defaultValue`}
        onKeyDown={onKeyDown}
        displayMode={displayMode}
        disabled={disabled}
        className='contract-input-agreement-text'
        placeholder={t('input.placeholder.paragraph-agreement-text')}
      />
    </Contract.Input.Base>
  );
};

export default ContractInputAgreementParagraph;
